export const DOCS_META = {
  badge: 'ANGULAR 21 FAMILY',
  angularVersion: '21.0.0 -> 21.2.8',
  packageVersion: '21.0.1',
  packageRange: '21',
  docsPath: 'angular-21'
};
